<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-transportadora') {
            next({ name: 'ven-transportadora-list' });
        } else if (to.name == 'agro-transportadora') {
            next({ name: 'agro-transportadora-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-transportadora') {
            this.$router.push({ name: 'ven-transportadora-list' });
        } else if (this.$route.name == 'agro-transportadora') {
            this.$router.push({ name: 'agro-transportadora-list' });
        }
    },
};
</script>
